<template>
  <v-snackbar
    v-model="snackbar.show"
    :timeout="snackbar.timeout"
    :color="snackbar.color"
    location="top"
    :close-on-content-click="true"
  >
    {{ snackbar.message }}
  </v-snackbar>

  <v-dialog v-model="localDialog" width="auto">
    <v-card>
      <v-card-text class="scrollable-dialog">
        <div class="new-form d-flex flex-column justify-space-between">
          <div class="title mb-5">{{ $t("edit_file") }}</div>
          <div class="">
            <div class="d-flex ga-5 flex-column">
              <label for="TaskName" class="label-name"
                >{{ $t("file_name") }} <span style="color: red">*</span>
              </label>
              <Input
                v-model="FileName"
                type="text"
                :placeholder="$t('file_name')"
              />
              <label for="TaskName" class="label-name"
                >{{ $t("task_name") }} <span style="color: red">*</span>
              </label>
              <Input
                v-model="TaskName"
                type="text"
                :placeholder="$t('task_name')"
              />
              <label for="users" class="label-name">{{
                $t("share_with")
              }}</label>
              <v-autocomplete
                v-model="usersId"
                :items="store?.getUsers"
                color="blue-grey-lighten-2"
                item-title="first_name"
                item-value="id"
                chips
                closable-chips
                multiple
                hide-details
                density="compact"
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip v-bind="props">
                    <img
                      style="height: 20px; width: 20px"
                      class="circle-img"
                      :src="item.raw.image"
                      alt=""
                    />
                  </v-chip>
                </template>
                <template v-slot:item="{ props, item }">
                  <v-list-item
                    v-bind="props"
                    :prepend-avatar="item.raw.image"
                    :title="item.raw.first_name + ' ' + item.raw.last_name"
                  ></v-list-item>
                </template>
              </v-autocomplete>
              <label for="folderId" class="label-name"
                >{{ $t("choose_folder") }}
              </label>
              <v-select
                class="new-form-v-select"
                :items="folders"
                v-model="folderId"
                item-title="name"
                item-value="file_id"
              ></v-select>
              <div
                v-if="!hide_file"
                class="d-flex align-center justify-center position-relative"
              >
                <img
                  width="100%"
                  v-if="Currentfile?.mimeType?.includes('image/')"
                  :src="Currentfile?.thumbnailLink"
                  alt=""
                />
                <iframe
                  v-else-if="Currentfile?.mimeType?.includes('video/')"
                  :src="drivePreviewLink"
                  width="100%"
                  height="400"
                  allow="autoplay"
                  frameborder="0"
                ></iframe>

                <div
                  v-else
                  class="d-flex align-center justify-center"
                  :style="{
                    background: 'black',
                    height: '200px',
                    width: '100%',
                  }"
                >
                  loading...
                  <!-- <svg
                    width="36"
                    height="32"
                    viewBox="0 0 36 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M19.4852 2.90909C12.0519 2.90909 6.02607 8.77009 6.02607 16C6.02607 23.23 12.0519 29.0909 19.4852 29.0909C26.9185 29.0909 32.9442 23.23 32.9442 16C32.9442 8.77009 26.9185 2.90909 19.4852 2.90909ZM3.03516 16C3.03516 7.16345 10.4001 0 19.4852 0C28.5702 0 35.9352 7.16345 35.9352 16C35.9352 24.8365 28.5702 32 19.4852 32C10.4001 32 3.03516 24.8365 3.03516 16Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16.4909 10.34V21.6608L25.0617 16.0004L16.4909 10.34ZM25.641 15.6177C25.6408 15.6177 25.6411 15.6177 25.641 15.6177V15.6177ZM15.1521 7.48659C15.9713 7.16153 17.0242 7.17586 17.9035 7.75658L27.3214 13.9766C28.0195 14.4377 28.4545 15.1788 28.4545 16.0004C28.4545 16.822 28.0195 17.5632 27.3214 18.0243L17.9035 24.2442C17.0242 24.825 15.9713 24.8393 15.1521 24.5143C14.337 24.1908 13.5 23.4044 13.5 22.2204V9.78045C13.5 8.59656 14.337 7.81 15.1521 7.48659Z"
                      fill="white"
                    />
                  </svg> -->
                </div>
                <div
                  class="position-absolute top-0 right-0 d-flex ga-2 align-center pa-4"
                >
                  <svg
                    @click="downloadFile"
                    width="21"
                    height="22"
                    viewBox="0 0 21 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="cursor-pointer hoverd"
                  >
                    <rect
                      x="0.367188"
                      width="20.1667"
                      height="22"
                      rx="3.66667"
                      fill="#F2F2F2"
                    />
                    <path
                      d="M15.9492 13.1386V15.9904C15.9492 16.3686 15.8204 16.7313 15.5912 16.9987C15.362 17.2661 15.0511 17.4163 14.727 17.4163H6.17144C5.84729 17.4163 5.53641 17.2661 5.3072 16.9987C5.07799 16.7313 4.94922 16.3686 4.94922 15.9904V13.1386M7.39366 9.57375L10.4492 13.1386M10.4492 13.1386L13.5048 9.57375M10.4492 13.1386V4.58301"
                      stroke="#666666"
                      stroke-width="1.1"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <svg
                    @click="hide_file = true"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="cursor-pointer hoverd"
                  >
                    <rect
                      x="0.867188"
                      width="20.5333"
                      height="22"
                      rx="3.66667"
                      fill="#F2F2F2"
                    />
                    <path
                      d="M14.0685 6.60033V6.01366C14.0685 5.19225 14.0685 4.78154 13.9086 4.46781C13.768 4.19184 13.5436 3.96746 13.2677 3.82685C12.9539 3.66699 12.5432 3.66699 11.7218 3.66699H10.5485C9.72708 3.66699 9.31637 3.66699 9.00264 3.82685C8.72667 3.96746 8.50229 4.19184 8.36168 4.46781C8.20182 4.78154 8.20182 5.19225 8.20182 6.01366V6.60033M9.66849 10.6337V14.3003M12.6018 10.6337V14.3003M4.53516 6.60033H17.7352M16.2685 6.60033V14.8137C16.2685 16.0458 16.2685 16.6618 16.0287 17.1324C15.8178 17.5464 15.4812 17.883 15.0673 18.0939C14.5967 18.3337 13.9806 18.3337 12.7485 18.3337H9.52182C8.28971 18.3337 7.67365 18.3337 7.20304 18.0939C6.78909 17.883 6.45253 17.5464 6.24161 17.1324C6.00182 16.6618 6.00182 16.0458 6.00182 14.8137V6.60033"
                      stroke="#CC0000"
                      stroke-width="1.1"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <div v-else class="position-relative">
                <div
                  style="z-index: 5"
                  class="d-flex align-center ga-2 justify-end cursor-pointer"
                  @click="restoreImage"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.035 0H2.96504C2.17911 0.00147869 1.4258 0.31434 0.870072 0.870072C0.31434 1.4258 0.00147869 2.17911 0 2.96504V13.035C0.00147869 13.8209 0.31434 14.5742 0.870072 15.1299C1.4258 15.6857 2.17911 15.9985 2.96504 16H13.035C13.8209 15.9985 14.5742 15.6857 15.1299 15.1299C15.6857 14.5742 15.9985 13.8209 16 13.035V2.96504C15.9985 2.17911 15.6857 1.4258 15.1299 0.870072C14.5742 0.31434 13.8209 0.00147869 13.035 0ZM13.2951 12.5874C12.8834 13.0012 12.3939 13.3295 11.8548 13.5532C11.3157 13.7769 10.7376 13.8917 10.1538 13.8909H8.67413C8.43846 13.8779 8.21673 13.7752 8.05449 13.6037C7.89225 13.4323 7.80184 13.2053 7.80184 12.9692C7.80184 12.7332 7.89225 12.5062 8.05449 12.3347C8.21673 12.1633 8.43846 12.0605 8.67413 12.0476H10.1538C10.8438 12.0476 11.5055 11.7735 11.9933 11.2856C12.4812 10.7978 12.7552 10.1361 12.7552 9.44615C12.7552 8.75622 12.4812 8.09454 11.9933 7.60669C11.5055 7.11883 10.8438 6.84476 10.1538 6.84476H4.86434L5.8042 7.78462C5.89759 7.86837 5.97294 7.97027 6.02563 8.08412C6.07833 8.19796 6.10726 8.32135 6.11068 8.44675C6.11409 8.57215 6.0919 8.69693 6.04548 8.81347C5.99905 8.93001 5.92936 9.03587 5.84065 9.12457C5.75195 9.21328 5.6461 9.28297 5.52956 9.32939C5.41302 9.37582 5.28823 9.398 5.16283 9.39459C5.03743 9.39118 4.91404 9.36224 4.8002 9.30955C4.68636 9.25685 4.58445 9.18151 4.5007 9.08811L1.45455 6.04196C1.43829 6.02648 1.42542 6.0078 1.41676 5.9871C1.40809 5.9664 1.40381 5.94412 1.4042 5.92168C1.4042 5.89971 1.40866 5.87797 1.41731 5.85777C1.42597 5.83758 1.43864 5.81935 1.45455 5.8042L4.5007 2.75804C4.58445 2.66465 4.68636 2.5893 4.8002 2.53661C4.91404 2.48391 5.03743 2.45497 5.16283 2.45156C5.28823 2.44815 5.41302 2.47033 5.52956 2.51676C5.6461 2.56319 5.75195 2.63288 5.84065 2.72158C5.92936 2.81029 5.99905 2.91614 6.04548 3.03268C6.0919 3.14922 6.11409 3.274 6.11068 3.3994C6.10726 3.5248 6.07833 3.64819 6.02563 3.76204C5.97294 3.87588 5.89759 3.97779 5.8042 4.06154L4.86434 5.0014H10.0392C11.2628 5.00953 12.4338 5.50005 13.2979 6.36643C13.709 6.77055 14.0355 7.25249 14.2583 7.78413C14.4812 8.31578 14.5959 8.88648 14.5958 9.46294C14.5923 10.6362 14.1247 11.7605 13.2951 12.5902V12.5874Z"
                      fill="#237276"
                    />
                  </svg>
                  <span class="mut"> {{ $t("restore_image") }} </span>
                </div>
                <v-file-upload
                  v-model="file"
                  :color="primary"
                  density="comfortable"
                  variant="comfortable"
                  clearable
                ></v-file-upload>
              </div>
            </div>
          </div>
          <div class="button-container d-flex justify-end mt-5">
            <v-btn
              color="white"
              variant="text"
              @click="UploadImage"
              class="upload-btn"
              hide-details
              clearable
            >
              {{ $t("update") }}
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="#fff"
                size="20"
              ></v-progress-circular>
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { VFileUpload } from "vuetify/labs/VFileUpload";
import Input from "@/components/crm/assets/Input.vue";
import apiClient from "@/core/buildRequest";
import { DriveStore } from "@/store/drive/DriveStore.js";
export default {
  name: "NewImage",
  props: ["fileId", "dialog"],
  components: { Input, VFileUpload },
  data() {
    return {
      localDialog: false,
      TaskName: "",
      snackbar: {
        color: "",
        show: false,
        message: "",
        timeout: 3000,
      },
      folders: [],
      Currentfile: null,
      file: null,
      folderId: "",
      usersId: [],
      store: DriveStore(),
      FileName: "",
      hide_file: false,
      loading: false,
    };
  },
  watch: {
    dialog(val) {
      this.localDialog = true;
    },
    localDialog(val) {
      if (this.localDialog) {
        this.hide_file = false;
        this.getAllFolders();
        this.store?.getAllUsers();
        this.getFileData();
      } else {
        this.Currentfile = null;
      }
      this.$emit("update:dialog", val);
    },
  },
  methods: {
    restoreImage() {
      this.hide_file = false;
      this.file = null;
    },
    async getAllFolders() {
      await apiClient.get("/my-drive/folders").then((response) => {
        this.folders = response.data.data;
      });
    },
    closeDialog() {
      this.localDialog = false;
    },
    UploadImage() {
      this.loading = true;
      if (this.FileName === "") {
        this.showSnackbar("File name is required", "error");
        return;
      }
      if (this.TaskName === "") {
        this.showSnackbar("Task name is required", "error");
        return;
      }
      if (this.file === null && this.hide_file === true) {
        this.showSnackbar("File is required", "error");
        return;
      }
      if (!this.file && this.hide_file === true) {
        this.showSnackbar("File is required", "error");
        return;
      }

      apiClient
        .post("/my-drive/update-file", {
          file: this.file ?? "",
          folder_id: this.folderId ?? "",
          task_name: this.TaskName,
          file_name: this.FileName,
          user_id: this.usersId,
          file_id: this.Currentfile?.file_id,
        })
        .then((response) => {
          this.store?.getAllDrive();
          this.showSnackbar(`Image Updated successfully`, "#237276");
          this.FileName = "";
          this.TaskName = "";
          this.file = null;
          this.folderId = "";
          this.closeDialog();
          this.loading = false;
        });
    },
    showSnackbar(message, color) {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    async getFileData() {
      try {
        await apiClient
          .get(`/my-drive/get/file/${this.fileId}`)
          .then((response) => {
            this.Currentfile = response.data.data;
            this.FileName = this.Currentfile.file_name;
            this.TaskName = this.Currentfile.task_name;
            this.folderId = this.Currentfile.folder_id;
            this.usersId = this.Currentfile.assignes?.map((user) => user.id);
          });
      } catch (err) {
        console.error("Error fetching Drive:", err);
      }
    },
    downloadFile() {
      window.open(this.Currentfile.webViewLink, "_blank");
    },
  },
  mounted() {},
  computed: {
    drivePreviewLink() {
      if (
        this.Currentfile?.mimeType?.includes("video/") &&
        this.Currentfile?.file_id
      ) {
        return `https://drive.google.com/file/d/${this.Currentfile.file_id}/preview`;
      }
      return null;
    },
  },
};
</script>
